import React, {useContext, useState} from 'react';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
// import Divider from '@material-ui/core/Divider';
import Logo from './Logo';
import history from '../../history';
import styled from 'styled-components';
import {MainContext} from '../../App';

const Drawer_ = styled(Drawer)`
&& {
  flex: 1 0 200px;
}
`
const link = setEstado => url => () => {
  setEstado(false);
  history.push(url);
}

const MainMenu = props => {
  const { estado, setEstado } = props;
  const link_ = link(setEstado)
  let GeraItemMenu_ = GeraItemMenu(link_)
  const { user } = useContext(MainContext);
  let menu;
  if (user) {
    const { scope=[] } = user;
    let modulosAExibir = scope
      .filter(sc => sc.match(/^modulos/))
      .map(sc => sc.substr(8).toLowerCase())
    if (modulosAExibir.includes('all')) {
      menu = Object.values(modulosUrl).map(modulo => (<GeraItemMenu_ {...modulo} />))
    } else {
      menu = modulosAExibir.map(modulo => <GeraItemMenu_ {...modulosUrl[modulo]}/>)
    }
  } else {
    menu = (
      <GeraItemMenu_ {...modulosUrl['logon']} />
    )
  }
  return (
    <Drawer_
      anchor="left"
      open={estado}
      onClose={()=>setEstado(false)}
    >
      <Logo onClick={link_("/")}/>
      {/* <Divider /> */}
      {menu}
    </Drawer_>
  )
}

// MELHORIA FUTURA: ESPECIFICAR ORDEM QUE MODULOS APARECERÃO...
const modulosUrl = {
  'logon': {
    link: "/logon",
    label: "Logon"
  },
  'empresas': {
    link: "/empresas",
    label: "Empresas"
  },
  'grpempresas': {
    link: "/grpempresas",
    label: "Grupos"
  },
  'metricas': {
    link: "/metricas",
    label: "Métricas"
  },
  'funcionarios': {
    link: "/funcionarios",
    label: "Funcionários"
  },
  'dre': {
    link: "/dre",
    label: "D.R.E."
  },
  'dre2': {
    link: "/dre2",
    label: "D.R.E. 2"
  },
  'esocial': {
    link: "/esocial",
    label: "eSocial"
  },
}

const GeraItemMenu = fnLink => ({ label, link }) => (
  <MenuItem onClick={fnLink(link)}>{label}</MenuItem>
)

export default MainMenu;
